import axios from "axios";
import { API_URL } from "../../utils/const";
import { getToken } from "../../utils/api";
import { customAxios } from "../axios";

const ENDPOINT_JOB_DETAIL = "v1/rms/job_logs"
const token = getToken();
export const getJobLogs = async(order_number: string) => {
  if (!token) {
    return;
  }
  try {
    const response = await customAxios({
      method: "GET",
      url: `${API_URL}${ENDPOINT_JOB_DETAIL}/?order_number=${order_number}&page_size=100`,
      headers: {
        "Authorization": `Bearer ${token}`,
      },
    });

    return response.data || response
  } catch (error) {
    console.error(error);
  }
}